<template>
  <div class="out-box" id="out-box">
    <div class="header-box">
      <div class="header clearfix">
        <a href="javascript:;" @click="handleSelect(1)" class="logoBox">
          <svg
            style="cursor: pointer"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="800px"
            height="260px"
            viewBox="0 0 800 260"
            version="1.1"
          >
            <title>logo+文</title>
            <g
              id="logo+文"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g id="编组" transform="translate(43.000000, 66.000000)">
                <g id="编组-24">
                  <path
                    d="M15.7285156,127.703125 C18.2871094,127.703125 21.0410156,127.380859 23.9902344,126.736328 L23.9902344,126.736328 L23.1113281,118.503906 C21.5292969,119.011719 20.2988281,119.265625 19.4199219,119.265625 C18.4433594,119.265625 17.7597656,118.933594 17.3691406,118.269531 C17.1152344,117.839844 16.9882812,116.960938 16.9882812,115.632812 L16.9882812,115.632812 L16.9882812,104.587891 L23.5507812,104.587891 L23.5507812,95.8867188 L16.9882812,95.8867188 L16.9882812,84.0507812 L5.03515625,90.1738281 L5.03515625,95.8867188 L0.640625,95.8867188 L0.640625,104.587891 L5.03515625,104.587891 L5.03515625,115.544922 C5.03515625,119.021484 5.37207031,121.536133 6.04589844,123.088867 C6.71972656,124.641602 7.75976562,125.798828 9.16601562,126.560547 C10.5722656,127.322266 12.7597656,127.703125 15.7285156,127.703125 Z M39.6347656,127.703125 C42.0957031,127.703125 44.1708984,127.263672 45.8603516,126.384766 C47.5498047,125.505859 49.2246094,124.03125 50.8847656,121.960938 L50.8847656,121.960938 L50.8847656,127 L62.0175781,127 L62.0175781,95.8867188 L50.09375,95.8867188 L50.09375,110.857422 C50.09375,113.689453 49.6396484,115.652344 48.7314453,116.746094 C47.8232422,117.839844 46.65625,118.386719 45.2304688,118.386719 C43.921875,118.386719 42.90625,117.976562 42.1835938,117.15625 C41.4609375,116.335938 41.0996094,114.949219 41.0996094,112.996094 L41.0996094,112.996094 L41.0996094,95.8867188 L29.1171875,95.8867188 L29.1171875,115.691406 C29.1171875,119.773438 30.0498047,122.795898 31.9150391,124.758789 C33.7802734,126.72168 36.3535156,127.703125 39.6347656,127.703125 Z M79.6542969,127.703125 C82.1152344,127.703125 84.1904297,127.263672 85.8798828,126.384766 C87.5693359,125.505859 89.2441406,124.03125 90.9042969,121.960938 L90.9042969,121.960938 L90.9042969,127 L102.037109,127 L102.037109,95.8867188 L90.1132812,95.8867188 L90.1132812,110.857422 C90.1132812,113.689453 89.6591797,115.652344 88.7509766,116.746094 C87.8427734,117.839844 86.6757812,118.386719 85.25,118.386719 C83.9414062,118.386719 82.9257812,117.976562 82.203125,117.15625 C81.4804688,116.335938 81.1191406,114.949219 81.1191406,112.996094 L81.1191406,112.996094 L81.1191406,95.8867188 L69.1367188,95.8867188 L69.1367188,115.691406 C69.1367188,119.773438 70.0693359,122.795898 71.9345703,124.758789 C73.7998047,126.72168 76.3730469,127.703125 79.6542969,127.703125 Z M119.673828,127.703125 C122.134766,127.703125 124.209961,127.263672 125.899414,126.384766 C127.588867,125.505859 129.263672,124.03125 130.923828,121.960938 L130.923828,121.960938 L130.923828,127 L142.056641,127 L142.056641,95.8867188 L130.132812,95.8867188 L130.132812,110.857422 C130.132812,113.689453 129.678711,115.652344 128.770508,116.746094 C127.862305,117.839844 126.695312,118.386719 125.269531,118.386719 C123.960938,118.386719 122.945312,117.976562 122.222656,117.15625 C121.5,116.335938 121.138672,114.949219 121.138672,112.996094 L121.138672,112.996094 L121.138672,95.8867188 L109.15625,95.8867188 L109.15625,115.691406 C109.15625,119.773438 110.088867,122.795898 111.954102,124.758789 C113.819336,126.72168 116.392578,127.703125 119.673828,127.703125 Z M158.931641,127 L165.699219,116.980469 L171.441406,127 L185.357422,127 L173.990234,110.710938 L184.595703,95.8867188 L171.441406,95.8867188 L165.699219,104.558594 L160.748047,95.8867188 L146.597656,95.8867188 L157.320312,110.710938 L146.011719,127 L158.931641,127 Z"
                    id="tuuux"
                    fill="#306EF2"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M6.6,56.5017173 C5.66308594,20.6148532 39.6052734,14.2752736 43.7396484,13.0512501 C47.8740234,11.8272267 51.6304688,9.13165009 51.6304688,9.13165009 C51.6304688,9.13165009 65.2066406,-2.30350616 75.6,0.419023582 C85.9933594,3.14155333 92.3784186,9.6062922 96.0896484,15.4076266 C99.8008783,21.2089611 108.492471,31.0241867 93.9390099,62.0163276 C91.0569644,68.1537514 85.9423889,75.8836828 82.3500977,78.1825656 C72.9065069,84.2259808 63.5643445,83.0861868 54.3236105,74.7631836"
                    id="路径-2备份"
                    stroke="#306EF2"
                    stroke-width="12"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle
                    id="椭圆形"
                    fill="#306EF2"
                    cx="37.5"
                    cy="52.5"
                    r="6.5"
                  />
                  <path
                    d="M102,28.3962524 C120.390519,26.5233698 133.821458,26.5233698 142.292816,28.3962524 C154.999853,31.2055763 180,42.0325656 180,78.1825656"
                    id="路径-3备份"
                    stroke="#306EF2"
                    stroke-width="12"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <path
                  d="M254.44,107.16 L254.44,104.6 L257.24,104.16 L257.24,102 C256.653333,102.08 255.72,102.226667 254.44,102.44 L254.44,102.44 L254.44,92.08 L257.28,92.08 L257.28,89.8 L239.12,89.8 L239.12,92.08 L242.16,92.08 L242.16,103.72 L238.24,104.04 L238.52,106.44 C242.84,106.066667 247.306667,105.573333 251.92,104.96 L251.92,104.96 L251.92,107.16 L254.44,107.16 Z M259.08,106.84 C261.853333,105.853333 264.28,104.36 266.36,102.36 C268.146667,103.773333 269.68,105.12 270.96,106.4 L270.96,106.4 L272.84,104.56 C271.56,103.333333 269.96,101.986667 268.04,100.52 C269.666667,98.4933333 271.04,96.04 272.16,93.16 L272.16,93.16 L272.16,91.04 L258.4,91.04 L258.4,93.52 L269.24,93.52 C268.28,95.6266667 267.186667,97.44 265.96,98.96 C264.36,97.7866667 262.36,96.44 259.96,94.92 L259.96,94.92 L258.2,96.64 C260.36,98.0266667 262.386667,99.4133333 264.28,100.8 C262.413333,102.506667 260.293333,103.733333 257.92,104.48 L257.92,104.48 L259.08,106.84 Z M251.92,94.48 L244.68,94.48 L244.68,92.08 L251.92,92.08 L251.92,94.48 Z M251.92,98.76 L244.68,98.76 L244.68,96.48 L251.92,96.48 L251.92,98.76 Z M244.68,103.52 L244.68,100.76 L251.92,100.76 L251.92,102.76 L244.68,103.52 Z M257.48,124.92 L257.48,110.76 L259.6,110.44 C261.12,116.44 265.293333,121.16 272.12,124.6 L272.12,124.6 L273.6,122.16 C270.533333,120.826667 268,119.16 266,117.16 C268.426667,115.72 270.333333,114.373333 271.72,113.12 L271.72,113.12 L270.16,111.12 C268.666667,112.56 266.746667,113.973333 264.4,115.36 C263.173333,113.733333 262.306667,111.96 261.8,110.04 C264.546667,109.48 267.053333,108.76 269.32,107.88 L269.32,107.88 L268.04,105.68 C261.053333,108.026667 252.226667,109.226667 241.56,109.28 L241.56,109.28 L242.4,111.72 C246.64,111.72 250.786667,111.506667 254.84,111.08 L254.84,111.08 L254.84,124.92 L257.48,124.92 Z M240.24,118.56 C242.64,117.733333 244.533333,116.933333 245.92,116.16 C247.28,115.386667 248.6,114.426667 249.88,113.28 L249.88,113.28 L247.72,111.96 C246.706667,112.813333 245.48,113.64 244.04,114.44 C242.466667,115.24 240.733333,115.88 238.84,116.36 L238.84,116.36 L240.24,118.56 Z M240.72,124.4 C243.813333,123.306667 246.213333,122.28 247.92,121.32 C249.653333,120.36 251.346667,119.146667 253,117.68 L253,117.68 L250.84,116.36 C249.346667,117.613333 247.733333,118.693333 246,119.6 C243.973333,120.666667 241.746667,121.506667 239.32,122.12 L239.32,122.12 L240.72,124.4 Z M311.24,114.84 L311.24,112.2 L299.04,112.2 L299.04,108.28 L309.12,108.28 L309.12,105.8 L299.04,105.8 L299.04,102 L309.12,102 L309.12,99.56 L299.04,99.56 L299.04,95.56 L310.8,95.56 L310.8,92.96 L299,92.96 C298.573333,91.3333333 298.093333,89.7466667 297.56,88.2 L297.56,88.2 L294.6,88.68 C295.186667,90.0133333 295.706667,91.44 296.16,92.96 L296.16,92.96 L286.76,92.96 C287.32,91.6266667 287.88,90.2266667 288.44,88.76 L288.44,88.76 L285.72,88.16 C283.533333,94 280.786667,98.68 277.48,102.2 L277.48,102.2 L279.32,104.4 C280.6,103.04 281.8,101.52 282.92,99.84 L282.92,99.84 L282.92,114.84 L311.24,114.84 Z M296.24,99.56 L285.8,99.56 L285.8,95.56 L296.24,95.56 L296.24,99.56 Z M296.24,105.8 L285.8,105.8 L285.8,102 L296.24,102 L296.24,105.8 Z M296.24,112.2 L285.8,112.2 L285.8,108.28 L296.24,108.28 L296.24,112.2 Z M311,125.04 L313.4,123.36 C312.173333,121.253333 310.48,118.853333 308.32,116.16 L308.32,116.16 L306,117.6 C308.16,120.373333 309.826667,122.853333 311,125.04 L311,125.04 Z M280.52,125.16 C282.253333,122.973333 283.786667,120.4 285.12,117.44 L285.12,117.44 L282.68,116.24 C281.426667,119.146667 279.933333,121.573333 278.2,123.52 L278.2,123.52 L280.52,125.16 Z M300.16,124.92 L302.96,124.28 C302.106667,121.56 301.106667,118.986667 299.96,116.56 L299.96,116.56 L297.32,117.16 C298.386667,119.32 299.333333,121.906667 300.16,124.92 L300.16,124.92 Z M291,125 L293.84,124.36 C293.173333,121.586667 292.44,119.106667 291.64,116.92 L291.64,116.92 L288.96,117.48 C289.76,119.613333 290.44,122.12 291,125 L291,125 Z M322.48,124.92 L322.48,123.2 L349.52,123.2 L349.52,124.92 L352.44,124.92 L352.44,90.16 L319.56,90.16 L319.56,124.92 L322.48,124.92 Z M349.52,120.48 L322.48,120.48 L322.48,92.88 L349.52,92.88 L349.52,120.48 Z M347.04,116.44 L347.04,113.8 L337.48,113.8 L337.48,107.44 L344.64,107.44 L344.64,104.88 L337.48,104.88 L337.48,99.12 L345.88,99.12 L345.88,96.52 L326.08,96.52 L326.08,99.12 L334.52,99.12 L334.52,104.88 L327.36,104.88 L327.36,107.44 L334.52,107.44 L334.52,113.8 L325,113.8 L325,116.44 L347.04,116.44 Z M342.56,113.72 L344.8,112.68 C344.08,111.133333 343.213333,109.666667 342.2,108.28 L342.2,108.28 L339.92,109.04 C340.88,110.346667 341.76,111.906667 342.56,113.72 L342.56,113.72 Z M363.12,124.96 L363.12,97.56 L374.52,97.56 C374.253333,99.3733333 373.893333,101.066667 373.44,102.64 C372,107.066667 369.04,110.76 364.56,113.72 L364.56,113.72 L366.48,116.08 C371.12,113.04 374.253333,109.253333 375.88,104.72 C379.72,108.64 382.773333,112.28 385.04,115.64 L385.04,115.64 L387.2,113.44 C384.293333,109.546667 380.8,105.68 376.72,101.84 C377.013333,100.666667 377.266667,99.24 377.48,97.56 L377.48,97.56 L388.92,97.56 L388.92,119.88 C388.92,121.186667 388.28,121.84 387,121.84 L387,121.84 L380.88,121.68 L381.68,124.56 L387.96,124.56 C390.546667,124.56 391.84,123.213333 391.84,120.52 L391.84,120.52 L391.84,94.76 L377.8,94.76 C377.986667,92.4133333 378.08,90.2266667 378.08,88.2 L378.08,88.2 L375.16,88.2 C375.16,90.3866667 375.053333,92.5733333 374.84,94.76 L374.84,94.76 L360.2,94.76 L360.2,124.96 L363.12,124.96 Z M400.32,124 C410.693333,117.813333 416.56,108.653333 417.92,96.52 L417.92,96.52 L417.92,94 L408.2,94 C408.76,92.3466667 409.24,90.6266667 409.64,88.84 L409.64,88.84 L406.76,88.36 C405.16,95.56 402.066667,101.293333 397.48,105.56 L397.48,105.56 L399.44,108 C402.693333,104.986667 405.266667,101.24 407.16,96.76 L407.16,96.76 L415.08,96.76 C414.493333,101.026667 413.266667,104.933333 411.4,108.48 C409.56,106.88 407.52,105.48 405.28,104.28 L405.28,104.28 L403.76,106.52 C405.84,107.533333 407.946667,108.946667 410.08,110.76 C407.28,115.08 403.373333,118.68 398.36,121.56 L398.36,121.56 L400.32,124 Z M424.4,124.96 L424.4,103.68 C426.453333,105.306667 429.24,107.88 432.76,111.4 L432.76,111.4 L434.52,108.76 C431.026667,105.613333 427.653333,102.853333 424.4,100.48 L424.4,100.48 L424.4,88.4 L421.44,88.4 L421.44,124.96 L424.4,124.96 Z M464.76,124.72 C467.32,124.72 468.6,123.386667 468.6,120.72 L468.6,120.72 L468.6,93.52 L473.88,93.52 L473.88,90.72 L438.2,90.72 L438.2,93.52 L465.72,93.52 L465.72,120 C465.72,121.386667 465.066667,122.08 463.76,122.08 C462.48,122.08 460.373333,122.026667 457.44,121.92 L457.44,121.92 L458.08,124.72 L464.76,124.72 Z M445.64,117.84 L445.64,114.32 L458.4,114.32 L458.4,99.64 L442.84,99.64 L442.84,117.84 L445.64,117.84 Z M455.64,111.68 L445.64,111.68 L445.64,102.24 L455.64,102.24 L455.64,111.68 Z M486.48,125 L486.48,108.08 C488,109.28 489.453333,110.64 490.84,112.16 L490.84,112.16 L492.48,109.68 C490.693333,107.946667 488.706667,106.4 486.52,105.04 C488.68,102.186667 490.28,99.3066667 491.32,96.4 L491.32,96.4 L491.32,93.96 L486.32,93.96 L487.48,93.52 C486.893333,91.76 486.133333,89.9066667 485.2,87.96 L485.2,87.96 L482.44,88.76 C483.373333,90.4666667 484.173333,92.2 484.84,93.96 L484.84,93.96 L478.6,93.96 L478.6,96.72 L488.44,96.72 C486.653333,101.093333 483.066667,105.586667 477.68,110.2 L477.68,110.2 L478.56,113.2 C480.56,111.466667 482.253333,109.866667 483.64,108.4 L483.64,108.4 L483.64,125 L486.48,125 Z M497.12,112.04 L497.12,92.68 L508.36,92.68 L508.36,112.04 L511.28,112.04 L511.28,89.92 L494.28,89.92 L494.28,112.04 L497.12,112.04 Z M491.64,125.24 C495.906667,123.426667 499.013333,120.84 500.96,117.48 C502.88,113.906667 503.92,109.133333 504.08,103.16 L504.08,103.16 L504.08,95.52 L501.28,95.52 L501.28,103.16 C501.2,108.173333 500.386667,112.266667 498.84,115.44 C497.213333,118.453333 494.293333,120.88 490.08,122.72 L490.08,122.72 L491.64,125.24 Z M510.44,124.36 C511.666667,124.36 512.586667,124.053333 513.2,123.44 C513.84,122.72 514.28,120.706667 514.52,117.4 L514.52,117.4 L511.84,116.56 C511.733333,119.04 511.506667,120.546667 511.16,121.08 C510.893333,121.506667 510.48,121.72 509.92,121.72 L509.92,121.72 L507.44,121.72 C506.56,121.72 506.12,121.24 506.12,120.28 L506.12,120.28 L506.12,111.96 L503.32,111.96 L503.32,120.88 C503.32,123.2 504.413333,124.36 506.6,124.36 L506.6,124.36 L510.44,124.36 Z M527.2,125.08 L527.2,98.6 C529.36,95.7466667 531.12,92.68 532.48,89.4 L532.48,89.4 L529.8,88.12 C527.24,94.3333333 523.16,99.84 517.56,104.64 L517.56,104.64 L518.48,107.64 C520.666667,105.826667 522.613333,103.986667 524.32,102.12 L524.32,102.12 L524.32,125.08 L527.2,125.08 Z M548.32,124.36 C550.24,124.36 551.56,123.88 552.28,122.92 C552.946667,121.96 553.426667,119.173333 553.72,114.56 L553.72,114.56 L551.04,113.68 C550.88,117.68 550.586667,119.986667 550.16,120.6 C549.653333,121.266667 548.88,121.6 547.84,121.6 L547.84,121.6 L541.44,121.6 C540.053333,121.6 539.36,120.973333 539.36,119.72 L539.36,119.72 L539.36,106.2 C544.346667,103.053333 548.693333,99.4933333 552.4,95.52 L552.4,95.52 L550.4,93.24 C547.2,96.84 543.52,100.026667 539.36,102.8 L539.36,102.8 L539.36,88.52 L536.48,88.52 L536.48,104.56 C534.693333,105.6 532.546667,106.706667 530.04,107.88 L530.04,107.88 L531.32,110.6 C533.213333,109.693333 534.933333,108.8 536.48,107.92 L536.48,107.92 L536.48,120.12 C536.48,122.946667 537.906667,124.36 540.76,124.36 L540.76,124.36 L548.32,124.36 Z M589.44,124.64 C591.6,124.64 592.68,123.48 592.68,121.16 L592.68,121.16 L592.68,88.44 L589.8,88.44 L589.8,120.44 C589.8,121.533333 589.346667,122.08 588.44,122.08 C586.76,122.08 584.76,122.013333 582.44,121.88 L582.44,121.88 L583.08,124.64 L589.44,124.64 Z M559.08,103.52 C562.92,99.92 566.346667,95.88 569.36,91.4 C571.92,94.12 574.92,97.76 578.36,102.32 L578.36,102.32 L580.24,100.32 C577.093333,96.32 573.746667,92.44 570.2,88.68 L570.2,88.68 L568.08,88.68 C564.906667,93.4533333 561.346667,97.6266667 557.4,101.2 L557.4,101.2 L559.08,103.52 Z M585.4,116.76 L585.4,91.84 L582.6,91.84 L582.6,116.76 L585.4,116.76 Z M574.56,124.32 C576.453333,124.32 577.72,124 578.36,123.36 C579.106667,122.533333 579.613333,120.44 579.88,117.08 L579.88,117.08 L577.16,116.2 C577,118.36 576.733333,119.84 576.36,120.64 C576.04,121.306667 575.186667,121.64 573.8,121.64 L573.8,121.64 L566.16,121.64 C565.146667,121.64 564.64,121.173333 564.64,120.24 L564.64,120.24 L564.64,103.72 L573.16,103.72 L573.16,110.92 C573.16,112.013333 572.626667,112.56 571.56,112.56 C570.36,112.56 569,112.48 567.48,112.32 L567.48,112.32 L568.2,115.04 C569.613333,115.12 571.08,115.16 572.6,115.16 C574.813333,115.08 575.933333,113.96 575.96,111.8 L575.96,111.8 L575.96,101.16 L561.72,101.16 L561.72,121.24 C561.72,123.293333 562.826667,124.32 565.04,124.32 L565.04,124.32 L574.56,124.32 Z M633.36,98.92 L633.36,96.4 L623.4,96.4 L624.96,93.24 L631.48,93.24 L631.48,90.76 L617.4,90.76 C617.106667,89.9333333 616.693333,88.9733333 616.16,87.88 L616.16,87.88 L613.08,88.36 C613.48,89.08 613.88,89.88 614.28,90.76 L614.28,90.76 L600.52,90.76 L600.52,93.24 L606.96,93.24 L608.24,96.4 L598.64,96.4 L598.64,98.92 L633.36,98.92 Z M620.4,96.4 L611.24,96.4 L609.96,93.24 L621.96,93.24 L620.4,96.4 Z M628.8,113.12 L628.8,101.28 L603.2,101.28 L603.2,113.12 L628.8,113.12 Z M626,106.12 L606,106.12 L606,103.56 L626,103.56 L626,106.12 Z M626,110.88 L606,110.88 L606,108.24 L626,108.24 L626,110.88 Z M617.92,120.08 L620.32,118.4 C619.466667,117.12 618.173333,115.613333 616.44,113.88 L616.44,113.88 L614,115.4 C615.6,117 616.906667,118.56 617.92,120.08 L617.92,120.08 Z M631.8,123.32 L634.2,121.64 C633.106667,119.8 631.373333,117.466667 629,114.64 L629,114.64 L626.68,116.08 C628.786667,118.64 630.493333,121.053333 631.8,123.32 L631.8,123.32 Z M600.48,123.84 C602.106667,121.573333 603.413333,118.813333 604.4,115.56 L604.4,115.56 L601.6,115 C600.826667,117.666667 599.626667,120.093333 598,122.28 L598,122.28 L600.48,123.84 Z M621.48,124.36 C622.946667,124.36 624.053333,124.106667 624.8,123.6 C625.626667,122.96 626.173333,121.266667 626.44,118.52 L626.44,118.52 L623.72,117.64 C623.56,119.666667 623.24,120.88 622.76,121.28 C622.44,121.6 621.84,121.76 620.96,121.76 L620.96,121.76 L612.56,121.76 C611.28,121.76 610.64,121.186667 610.64,120.04 L610.64,120.04 L610.64,115.36 L607.68,115.36 L607.68,120.64 C607.68,123.12 609.026667,124.36 611.72,124.36 L611.72,124.36 L621.48,124.36 Z M646.72,124.92 L646.72,108 C648.266667,109.093333 649.88,110.493333 651.56,112.2 L651.56,112.2 L653.16,109.72 C651.106667,107.88 648.96,106.32 646.72,105.04 C649.013333,102.106667 650.666667,99.2266667 651.68,96.4 L651.68,96.4 L651.68,93.96 L646.64,93.96 L647.48,93.64 C647.026667,92.1466667 646.32,90.32 645.36,88.16 L645.36,88.16 L642.6,88.92 C643.4,90.44 644.133333,92.12 644.8,93.96 L644.8,93.96 L638.64,93.96 L638.64,96.72 L648.76,96.72 C646.92,101.066667 643.226667,105.533333 637.68,110.12 L637.68,110.12 L638.56,113.16 C640.346667,111.666667 642.12,110.04 643.88,108.28 L643.88,108.28 L643.88,124.92 L646.72,124.92 Z M674.2,123.64 L674.2,120.8 L664.12,120.8 L664.12,103.28 L673.24,103.28 L673.24,100.44 L664.12,100.44 L664.12,88.52 L661.16,88.52 L661.16,100.44 L652.24,100.44 L652.24,103.28 L661.16,103.28 L661.16,120.8 L650.84,120.8 L650.84,123.64 L674.2,123.64 Z M713.64,123.32 L713.64,120.56 L683.48,120.56 L683.48,92.72 L712.48,92.72 L712.48,89.96 L680.72,89.96 L680.72,123.32 L713.64,123.32 Z M687.6,117.68 C692.186667,115.68 696.24,112.8 699.76,109.04 C702.826667,111.866667 705.56,114.706667 707.96,117.56 L707.96,117.56 L710.2,115.32 C707.64,112.52 704.8,109.68 701.68,106.8 C704.053333,103.786667 706.146667,100.226667 707.96,96.12 L707.96,96.12 L705.36,94.72 C703.653333,98.56 701.68,101.92 699.44,104.8 C696.373333,102.08 692.946667,99.28 689.16,96.4 L689.16,96.4 L687.08,98.4 C690.706667,101.173333 694.2,104.04 697.56,107 C694.226667,110.573333 690.346667,113.266667 685.92,115.08 L685.92,115.08 L687.6,117.68 Z"
                  id="聚焦国内外可视化创意社区"
                  fill="#3B4968"
                  fill-rule="nonzero"
                />
                <path
                  d="M292.18043,78 C296.402019,78 299.555182,76.4590936 301.639917,73.3772808 C302.551989,72.0047087 303.008025,69.5962331 303.008025,66.151854 L303.008025,66.151854 L303.008025,22.7604473 C303.008025,18.642731 301.405384,15.5609182 298.200104,13.5150088 C296.871085,12.6344909 294.74726,12.1942319 291.828631,12.1942319 L291.828631,12.1942319 L243.553974,12.1942319 C241.755889,12.1942319 240.270515,12.4014126 239.097851,12.815774 C238.029424,13.1783402 236.947968,13.9034726 235.853482,14.9911713 C233.951161,16.9334903 233,19.7563273 233,23.4596822 L233,23.4596822 L233,66.8122425 C233,69.039435 233.247562,70.8263685 233.742687,72.173043 C234.081457,73.1053561 234.772025,74.1024132 235.814393,75.1642142 C237.742773,77.0547381 240.465959,78 243.98395,78 L243.98395,78 L292.18043,78 Z M290.655967,70.8134197 L245.664768,70.8134197 C243.68427,70.8134197 242.303132,70.4508534 241.521356,69.725721 C240.661403,68.8969982 240.231426,67.4985285 240.231426,65.5303119 L240.231426,65.5303119 L240.231426,24.8969982 C240.231426,23.2913479 240.400811,22.1777516 240.739581,21.5562095 C241.052291,20.9864626 241.560445,20.4685109 242.264043,20.0023543 C242.889464,19.5879929 244.257572,19.3808122 246.368367,19.3808122 L246.368367,19.3808122 L290.069635,19.3808122 C292.206489,19.3808122 293.743981,19.8599176 294.682112,20.8181283 C295.41177,21.5173632 295.776598,22.8769865 295.776598,24.8969982 L295.776598,24.8969982 L295.776598,65.5303119 C295.776598,67.343143 295.39874,68.6768687 294.643024,69.5314891 C293.913366,70.3861095 292.584347,70.8134197 290.655967,70.8134197 L290.655967,70.8134197 Z M258.148428,47.0052501 C258.546159,47.0052501 260.394439,46.8512022 263.693266,46.5431063 C265.845693,46.3535088 267.998119,45.9387644 270.150546,45.2988729 C275.250861,46.4364577 279.918351,47.0052501 284.153016,47.0052501 L284.153016,47.0052501 L289.838229,47.0052501 L289.838229,41.5661727 L283.38095,41.5661727 C283.053407,41.5661727 282.281341,41.5306232 281.064752,41.4595241 C280.503249,41.4358245 279.660995,41.4002749 278.53799,41.3528756 C281.439087,39.6227987 283.49793,38.2363672 284.714518,37.1935811 C286.749965,35.4872038 287.767689,33.6860279 287.767689,31.7900532 C287.767689,30.3917718 287.252978,29.183088 286.223557,28.1640016 C284.492257,26.4576243 281.602858,25.6044357 277.555361,25.6044357 L277.555361,25.6044357 L259.095964,25.6044357 L259.552185,23.933608 L252.638685,23.933608 C251.749639,26.0428799 251.141344,27.3463625 250.813801,27.8440558 C249.854568,29.2660369 248.80175,30.4391712 247.655349,31.3634589 L247.655349,31.3634589 L247.655349,37.8334725 C249.78438,36.8380858 251.410398,35.8782486 252.533403,34.953961 C253.58622,34.1481717 254.744319,32.9513377 256.0077,31.3634589 L256.0077,31.3634589 L276.642919,31.3634589 C279.263264,31.3634589 280.573437,31.6952544 280.573437,32.3588456 C280.573437,33.0224367 279.988539,33.7452771 278.818742,34.5273666 C277.508569,35.4279546 274.455399,37.0395331 269.659231,39.3621021 C265.986068,37.6794246 263.517797,36.4588909 262.254416,35.700501 L262.254416,35.700501 L252.743966,35.700501 C255.223936,37.5964757 257.902771,39.445051 260.780472,41.246227 C258.066543,41.4595241 255.387708,41.5661727 252.743966,41.5661727 L252.743966,41.5661727 L247.409692,41.5661727 L247.409692,47.0052501 L258.148428,47.0052501 Z M281.170188,54.9609888 C282.359677,54.9609888 283.525843,54.6610866 284.668685,54.0612822 C285.741558,53.5059078 286.569536,52.7617061 287.152618,51.828677 C287.852318,50.7401432 288.213829,49.6627168 288.237152,48.5963979 L288.237152,48.5963979 L282.114783,48.5963979 C281.974843,49.440567 281.368437,49.8626516 280.295564,49.8626516 L280.295564,49.8626516 L247.409692,49.8626516 L247.409692,54.9609888 L281.170188,54.9609888 Z M280.505474,64.5078752 C284.91358,64.5078752 287.490806,62.3863449 288.237152,58.1432843 L288.237152,58.1432843 L282.114783,58.1432843 C281.998166,58.6542288 281.869888,58.9763459 281.729948,59.1096358 C281.520038,59.3095706 281.065234,59.409538 280.365534,59.409538 L280.365534,59.409538 L247.409692,59.409538 L247.409692,64.5078752 L280.505474,64.5078752 Z M341.940461,77.8834609 C345.119682,77.8057681 347.360773,77.559741 348.663733,77.1453796 C350.539995,76.5756327 351.960221,75.552678 352.924411,74.0765156 C354.071016,72.3413773 354.644318,69.2725132 354.644318,64.8699235 L354.644318,64.8699235 L354.644318,51.9729253 C355.009147,52.9052384 355.387005,53.8505003 355.777893,54.808711 L355.777893,54.808711 L356.989645,57.9164214 C358.422901,61.4125956 359.817068,64.0541495 361.172146,65.841083 C363.465355,68.8193055 366.006126,71.1371395 368.79446,72.7945851 C372.182155,74.8145968 377.250669,76.4072984 384,77.5726898 L384,77.5726898 L384,70.5803414 C381.341962,69.9587993 379.061783,69.3243084 377.159462,68.6768687 C375.048667,67.9776339 373.00302,66.9417304 371.022521,65.5691583 C369.198378,64.274279 367.543619,62.4355503 366.058245,60.0529723 C370.670722,55.6762802 374.149625,52.8922896 376.494952,51.7010006 C378.162741,50.8722778 380.664423,50.41907 384,50.3413773 L384,50.3413773 L384,44.0871101 C379.022694,44.2942908 375.452584,44.9546792 373.289671,46.0682755 C371.335232,47.0523838 367.882388,49.5644497 362.931142,53.6044732 L362.931142,53.6044732 L361.36759,49.9917599 L353.979808,49.9917599 C353.406506,48.3861095 352.585642,47.1948205 351.517215,46.4178929 C350.292432,45.5373749 348.520407,44.9805768 346.201139,44.7474985 L346.201139,44.7474985 L349.171887,42.5721012 L376.964018,42.5721012 C381.08137,42.5721012 383.127017,40.3708064 383.100958,35.9682166 L383.100958,35.9682166 L383.061869,31.4620365 C383.03581,28.6909947 381.40711,26.852266 378.17577,25.9458505 C379.348434,23.6668629 379.934766,21.7633902 379.934766,20.2354326 C379.934766,18.5002943 379.048753,17.0629782 377.276728,15.9234844 C376.130123,15.1724544 373.250582,14.7969394 368.638105,14.7969394 L368.638105,14.7969394 L327.829407,14.7969394 L328.533005,12 L321.106135,12 C320.246182,14.4602707 319.164725,16.260153 317.861765,17.3996469 C316.636983,18.4614479 314.79981,19.2254267 312.350246,19.6915833 L312.350246,19.6915833 L312.350246,26.606239 C315.008284,26.2954679 317.145138,25.7645674 318.760808,25.0135374 C320.220123,24.3143025 321.835793,23.1618599 323.607818,21.5562095 L323.607818,21.5562095 L370.358012,21.5562095 C371.765208,21.5562095 372.468807,21.8151854 372.468807,22.3331371 C372.468807,22.8769865 372.064889,23.6021189 371.257054,24.5085344 L371.257054,24.5085344 L370.123479,25.8681577 L320.324359,25.8681577 C317.483907,25.8681577 315.516438,26.3990583 314.421952,27.4608593 C313.353525,28.4967628 312.819311,30.7239553 312.819311,34.1424367 C312.819311,37.6127134 313.353525,39.891701 314.421952,40.9793996 C315.46432,42.0412007 317.314522,42.5721012 319.97256,42.5721012 L319.97256,42.5721012 L337.327983,42.5721012 C332.376737,44.7216009 327.998792,46.3790465 324.19415,47.5444379 C320.650099,48.606239 316.636983,49.4738081 312.154802,50.1471454 L312.154802,50.1471454 L312.154802,56.0906416 C318.487186,55.3396115 326.174648,53.3454974 335.217189,50.108299 L335.217189,50.108299 L343.386746,50.1471454 C336.090172,54.0835786 330.774096,56.5826957 327.438519,57.6444968 C323.347226,58.9393761 318.122357,59.949382 311.763914,60.6745144 L311.763914,60.6745144 L311.763914,66.3460859 C321.848822,65.5432607 330.305031,63.523249 337.132539,60.2860506 C339.764518,59.0170689 343.204332,57.0229547 347.45198,54.3037081 L347.45198,54.3037081 L347.45198,57.6056504 C341.197774,61.826957 335.764432,64.7922307 331.151954,66.5014715 C325.366813,68.6768687 318.904133,70.1789288 311.763914,71.0076516 L311.763914,71.0076516 L311.763914,76.6792231 C321.770645,75.7987051 330.396238,73.6880518 337.640694,70.3472631 C340.272672,69.1300765 343.543101,67.2007063 347.45198,64.5591524 L347.45198,64.5591524 L347.491069,66.967628 C347.517128,68.9358446 347.048063,70.3084167 346.083873,71.0853443 C345.276038,71.732784 343.8949,72.0565038 341.940461,72.0565038 L341.940461,72.0565038 L341.940461,77.8834609 Z M344.285788,36.5897587 L323.646907,36.5897587 C321.692467,36.5897587 320.715247,36.1883461 320.715247,35.3855209 L320.715247,35.3855209 L320.715247,33.3266627 C320.715247,32.3425544 321.26249,31.8505003 322.356976,31.8505003 L322.356976,31.8505003 L344.285788,31.8505003 L344.285788,36.5897587 Z M372.898783,36.5897587 L351.517215,36.5897587 L351.517215,31.8505003 L371.139788,31.8505003 C373.146346,31.8505003 374.319009,31.9411418 374.657779,32.122425 C375.074726,32.3296057 375.2832,32.873455 375.2832,33.7539729 L375.2832,33.7539729 L375.2832,34.9582107 C375.2832,36.0459094 374.488394,36.5897587 372.898783,36.5897587 L372.898783,36.5897587 Z"
                  id="图象"
                  fill="#3B4968"
                  fill-rule="nonzero"
                />
              </g>
            </g>
          </svg>
        </a>

        <ul class="el-menu-demoMain el-menu--horizontal el-menu" id="navMenu">
          <li
            class="el-menu-item navitems"
            :class="activeIndex == item.Id ? 'is-active' : ''"
            v-for="(item, index) in navList"
            :key="index"
          >
            <a
              href="javascript:;"
              @click="handleSelect(item.Id)"
              style="cursor: pointer"
            >
              {{ item.Title }}
            </a>
            <img src="./assets/img/new.svg" v-if="item.Id==4" alt="" class="new">
          </li>
        </ul>
        <!-- <el-menu
          :default-active="activeIndex"
          class="el-menu-demoMain"
          mode="horizontal"
          text-color="#374567"
          active-text-color="#3E66F5"
        >
          <el-menu-item index="1" @click="gohome" v-if="!searchFlag">
            <span slot="title">首 页</span>
          </el-menu-item>
          <el-menu-item index="2" @click="goWorks" v-if="!searchFlag">
            <span slot="title">作 品</span>
          </el-menu-item>
          <el-menu-item index="3" @click="goTool" v-if="!searchFlag">
            <span slot="title">工 具</span>
          </el-menu-item>
        </el-menu> -->
        <div class="funcIcon">
          <ul>
            <li id="btnsearch">
              <a
                href="javascript:;"
                @click="searchInputShow($event)"
                style="cursor: pointer"
              >
                <i class="iconfont iconsousuo pointer"></i>
              </a>
            </li>
            <li @click="gouploadwork()">
              <i class="iconfont iconshangchuan pointer"></i>
            </li>
            <li v-if="hasToken" @click="goNews()" class="redDotBox">
              <i class="iconfont icontongzhi pointer"></i>
              <span
                class="redDot"
                v-if="newSData.ReadCount != 0 && newSData.ReadCount <= 99"
                >{{ newSData.ReadCount }}</span
              >
              <span
                class="redDot"
                v-if="newSData.ReadCount != 0 && newSData.ReadCount > 99"
                >99+</span
              >
            </li>
            <li v-if="hasToken">
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  <!-- <img
                    :src="UserMainData.HeadImg"
                    alt=""
                    v-if="!UserMainData.SysHeadImg && UserMainData.HeadImg"
                  /> -->
                  <!-- <img
                    :src="showImgs(UserMainData.SysHeadImg)"
                    alt=""
                    v-if="UserMainData.SysHeadImg"
                  /> -->
                  <img
                    :src="UserMainData.avatarUrl"
                    alt=""
                    v-if="UserMainData.avatarUrl"
                  />
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="32px"
                    height="32px"
                    viewBox="0 0 32 32"
                    version="1.1"
                  >
                    <title>头像</title>
                    <g
                      id="页面-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="隐私政策"
                        transform="translate(-1528.000000, -19.000000)"
                        fill-rule="nonzero"
                      >
                        <g
                          id="头像"
                          transform="translate(1528.000000, 19.000000)"
                        >
                          <path
                            d="M0,16.0000186 L0,16.000021 C0,24.8365938 7.16344584,32.0000397 16.0000186,32.0000397 C24.8365914,32.0000397 32.0000372,24.8365938 32.0000372,16.000021 L32.0000372,16.000021 C32.0000372,7.16344825 24.8365914,2.41593406e-06 16.0000186,2.41593406e-06 C7.16344584,2.41593406e-06 0,7.16344825 0,16.000021 L0,16.0000186 Z"
                            id="路径"
                            fill="#EDEEF5"
                          />
                          <path
                            d="M20.842118,13.0000151 C23.8421215,8.92107288 23.2631739,15.6842276 20.4736957,15.9473873 C16.0789406,17.3947577 20.842118,13.0000151 20.842118,13.0000151 Z"
                            id="路径"
                            fill="#EFE7E6"
                          />
                          <path
                            d="M12.1052641,16.0789562 C12.2368433,16.5789568 13.2105279,18.6315904 11.026316,21.8421192 C8.84210404,25.0526542 16.0526343,26.7894999 16.0526343,26.7894999 C16.0526343,26.7894999 22.894736,24.4737066 23.2631739,23.3421209 C25.526336,21.4210656 19.0526378,23.3684367 20.2894861,16.2894877 C17.3421139,14.4210637 12.1052578,16.0789612 12.1052578,16.0789612 L12.1052641,16.0789562 Z"
                            id="路径"
                            fill="#EDE7E6"
                          />
                          <path
                            d="M16.0000186,32.0000372 C21.8252754,32.0000372 26.9221251,28.8861399 29.7202533,24.2328719 C29.7198323,24.2255035 29.7198323,24.217293 29.7192007,24.2105561 C28.9122529,22.9825547 23.3682558,21.1227619 21.1928783,21.1227619 C16.8772795,28.6667707 11.0526477,22.4210791 11.1579291,21.1930776 C8.14381935,20.9859196 4.51160887,23.1625549 2.49601278,24.5770816 C5.33559421,29.0379305 10.3202406,32.0000372 16.0000285,32.0000372 L16.0000186,32.0000372 Z"
                            id="路径"
                            fill="#586ABA"
                          />
                          <path
                            d="M12.2764018,17.3158014 C12.4541051,17.9473803 17.0480198,22.2368696 21.2107434,21.1842122 C19.9924264,19.6842104 20.424005,17.3421139 20.5000051,15.9473623 C20.9313744,14.9999925 12.4031519,16.4736785 12.2764018,17.3157858 L12.2764018,17.3158014 Z"
                            id="路径"
                            fill="#E3DCDB"
                          />
                          <path
                            d="M16.5789568,5.26316237 C18.2894838,5.57895337 20.6842116,5.7368473 21.0000244,8.13158759 C24.3421221,22.0789788 9.39476093,24.0263561 11.3157944,9.39474843 C12.2894799,4.21052365 16.5789568,5.26314987 16.5789568,5.26314987 L16.5789568,5.26316237 Z"
                            id="路径"
                            fill="#F7EDEB"
                          />
                          <path
                            d="M12.9705463,7.15791458 C13.8970724,7.78949344 15.7676027,9.8596021 20.3027736,8.84212591 C20.6909835,10.3509683 20.4968792,10.3509683 21.5467751,11.947392 C22.3143541,12.2105501 24.5379379,4.6579148 18.026146,3.6316011 C10.4029809,2.44739035 9.42360472,9.15792003 11.382357,11.5789853 C11.8587794,11.0789848 11.4882518,8.34213783 12.9705682,7.1579177 L12.9705463,7.15791458 Z"
                            id="路径"
                            fill="#586ABA"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
                <el-dropdown-menu slot="dropdown" class="MainMenu">
                  <el-dropdown-item command="a">我的作品</el-dropdown-item>
                  <el-dropdown-item command="b">我的收藏</el-dropdown-item>
                  <el-dropdown-item command="c">我的关注</el-dropdown-item>
                  <el-dropdown-item command="d">我的资料</el-dropdown-item>
                  <el-dropdown-item command="f">个人中心</el-dropdown-item>
                  <el-dropdown-item command="e">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>

          <span class="login commonSpan" v-if="!hasToken" @click="loginProject"
            >登录</span
          >
        </div>
        <!-- 搜索框 -->
        <!-- v-if="searchFlag" -->
        <div class="mainsearchBox clearfix">
          <a
            href="javascript:;"
            @click="searchInputHide()"
            style="cursor: pointer"
          >
            <i class="iconfont iconguanbi1"></i>
            <!-- 关闭 -->
          </a>
          <!-- <el-input v-model="inputText" placeholder=""></el-input> -->
          <div class="el-input">
            <!-- <form action="#"> -->
            <input
              id="inputText"
              autocomplete="off"
              class="el-input__inner"
              type="text"
              v-model="inputText"
              @keydown="searchWorks($event)"
            />
            <!-- </form> -->
          </div>
          <a @click="gosearch()" href="javascript:;">
            <i class="iconfont iconsousuo pointer"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="content-box" ref="contentBox" id="content-box">
      <router-view></router-view>
    </div>
    <div class="footerBox">
      <div class="footer clearfix">
        <!-- <div class="foot_logo">
          <img
            src="https://static.zcool.cn/git_z/z/common/images/svg/logo.svg"
            alt=""
          />
        </div> -->
        <div class="contentList">
          <ul class="clearfix">
            <li @click="footernav(1)">
              <a href="javascript:;">关于我们</a>
            </li>
            <li @click="footernav(2)">
              <a href="javascript:;">用户协议</a>
            </li>
            <li @click="footernav(3)">
              <a href="javascript:;">隐私政策</a>
            </li>
            <li @click="footernav(4)">
              <a href="javascript:;">侵权投诉</a>
            </li>
            <li @click="footernav(5)">
              <a href="javascript:;">联系我们</a>
            </li>
            <li @click="footernav(6)">
              <a href="javascript:;">版权声明</a>
            </li>
          </ul>
          <p class="copyright" @click="goLink">
            Copyright©2013-2026 ceshi.CN 鲁ICP备19059293号-2
          </p>
        </div>
        <div class="qrCode">
          <div class="qrCodeBox">
            <img src="./assets/img/qrCode.png" alt="" />
            <p>官方公众号</p>
          </div>
          <div class="qrCodeBox">
            <img src="./assets/img/qrCode1.png" alt="" />
            <p>官方微信</p>
          </div>
        </div>
      </div>
    </div>
    <span
      class="goTop"
      id="to-top-btn"
      @click="goTop($event)"
      style="display: none"
    >
      <i class="iconfont iconzhiding"></i>
    </span>
    <commponent-dialog
      @callFather="activeSon"
      :loginVisible="loginVisible"
      v-on:dialog-change="dialogChange"
    ></commponent-dialog>
    <!-- <div class="dialogbox" v-if="popalert">
        <i class="el-icon-circle-close close" @click="closealert"></i>
        <div class="pop1" v-if="getb">
          <img src="./assets/img/getB.png" alt="">
          <p class="nums">{{getbnum}}</p>
        </div>
        <div class="pop1" v-if="hotpop">
          <img src="./assets/img/TIPS.png" alt="">
        </div>
    </div> -->
    
  </div>
</template>

<script>
import CommponentDialogWe from "@/components/CommponentDialogWe";
import api from "@/utils/request.js";
import { Loading } from 'element-ui';
export default {
  name: "Main",
  data() {
    return {
      popalert:false,//弹窗容器
      hotpop:true,//广告弹窗
      getb:false,//金币弹窗
      getbnum:0,//金币数量
      popmask:'',//遮罩
      navList: [
        {
          Title: "首页",
          Id: "1",
        },
        {
          Title: "作品",
          Id: "2",
        },
        {
          Title: "工具",
          Id: "3",
        },
        {
          Title: "资源",
          Id: "4",
        },
        // {
        //   Title: "教程",
        //   Id: "5"
        // },
        // {
        //   Title: "周练",
        //   Id: "6"
        // },
        // {
        //   Title: "企业合作",
        //   Id: "7"
        // },
        // {
        //   Title: "软件下载",
        //   Id: "8"
        // },
        // {
        //   Title: "新闻大事件",
        //   Id: "9"
        // }
        {
          Title: "图象超级助理",
          Id: "10"
        },
      ],
      goTopFlag: true,
      ifDot: false,
      inputText: "",
      searchFlag: false,
      accessKeyId: "",
      accessKeySecret: "",
      stsToken: "",
      endpoint: "",
      bucket: "",
      activeRouter: "",
      activeRouterName: "",
      hasToken: false,
      checkedBox: false,
      havePassword: false,
      activeIndex: sessionStorage.getItem("menuIdenx") || "1",
      getDetailParame: {
        UserId: "",
        FWUserId: "",
        PersonalCenterType: "1", //1 我的作品 2 我的收藏 3 我的关注
        Paging: {
          PageIndex: 1,
          PageSize: 20,
        },
      },
      usercenterParame: {
        UserId: "",
        PersonalCenterType: "", //1 我的作品 2 我的收藏 3 我的关注
      },
      registeredVisible: false,
      loginVisible: false,
      registeredSuccessVisible: false,
      emailFlag: false,
      emailLoginFlag: false,
      checkboxFlag: false,
      passwordFlag: false,
      sameFlag: false,
      visibleFlag: false,
      visibleSureFlag: false,
      visibleLoginFlag: false,

      UserMainData: {},
      newslistParame: {
        LoginUserId: "",
        FWType: 0,
        Paging: {
          PageIndex: 1,
          PageSize: 20,
        },
      },
      newSData: {},
    };
  },
  watch: {
    $route: function () {
      this.searchInputHide();
      if (this.$route.meta.title == "作品") {
        this.activeIndex = "2";
      } else if (this.$route.meta.title == "首页") {
        this.activeIndex = "1";
      } else if (this.$route.meta.title == "工具") {
        this.activeIndex = "3";
      } else if (this.$route.meta.title == "资源") {
        this.activeIndex = "4";
      } else if (this.$route.meta.title == "教程") {
        this.activeIndex = "5";
      } else if (this.$route.meta.title == "周练") {
        this.activeIndex = "6";
      } else if (this.$route.meta.title == "企业合作") {
        this.activeIndex = "7";
      } else if (this.$route.meta.title == "软件下载") {
        this.activeIndex = "8";
      } else if (this.$route.meta.title == "新闻事迹") {
        this.activeIndex = "9";
      }else if (this.$route.meta.title == "图象超级助理") {
      this.activeIndex = "10";
    }

      if (this.$storage.get("token")) {
        this.hasToken = true;
        this.getUserDetail();
      } else {
        this.hasToken = false;
      }

      // if (this.$route.meta.title == "公告列表") {
      //   if (this.$route.query.PageIndex) {
      //     if (this.hasToken) {
      //       this.newslistParame.Paging.PageIndex = this.$route.query.PageIndex;
      //       this.getnewslist(this.newslistParame);
      //     }
      //   }
      // } else {
      //   if (this.hasToken) {
      //     this.newslistParame.Paging.PageIndex = 1;
      //     this.getnewslist(this.newslistParame);
      //   }
      // }
    },
  },
  mounted: function () {
    // this.showalert()
    window.self = this;
    window.addEventListener("scroll", function (e) {
      if (document.documentElement.scrollTop != 0) {
        $("#to-top-btn").show();
      } else {
        $("#to-top-btn").hide();
      }
    });
    if (this.$route.meta.title == "作品") {
      this.activeIndex = "2";
    } else if (this.$route.meta.title == "首页") {
      this.activeIndex = "1";
    } else if (this.$route.meta.title == "工具") {
      this.activeIndex = "3";
    } else if (this.$route.meta.title == "资源") {
      this.activeIndex = "4";
    } else if (this.$route.meta.title == "教程") {
      this.activeIndex = "5";
    } else if (this.$route.meta.title == "周练") {
      this.activeIndex = "6";
    } else if (this.$route.meta.title == "企业合作") {
      this.activeIndex = "7";
    } else if (this.$route.meta.title == "软件下载") {
      this.activeIndex = "8";
    } else if (this.$route.meta.title == "新闻事迹") {
      this.activeIndex = "9";
    }else if (this.$route.meta.title == "图象超级助理") {
      this.activeIndex = "10";
    }

    if (this.$storage.get("token")) {
      this.hasToken = true;
      // this.getUserDetail();
    } else {
      this.hasToken = false;
    }

    // if (this.$storage.get("PCAccessKeyId")) {
    //   this.accessKeyId = this.$storage.get("PCAccessKeyId");
    // }
    // if (this.$storage.get("PCAccessKeySecret")) {
    //   this.accessKeySecret = this.$storage.get("PCAccessKeySecret");
    // }
    // if (this.$storage.get("PCStsToken")) {
    //   this.stsToken = this.$storage.get("PCStsToken");
    // }
    // if (this.$storage.get("PCEndpoint")) {
    //   this.endpoint = this.$storage.get("PCEndpoint");
    // }
    // if (this.$storage.get("PCBucket")) {
    //   this.bucket = this.$storage.get("PCBucket");
    // }
    if (this.hasToken == true) {
      this.getUserDetail();
      // this.getnewslist(this.newslistParame);
    }
    // this.fetchSourceData()
    //   .then(res => {
    //     if (this.hasToken == true) {
    //       this.getUserDetail();
    //       this.getnewslist(this.newslistParame);
    //     }
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   });
    this.remWatch();
  },
  components: {
    "commponent-dialog": CommponentDialogWe,
  },
  methods: {
    // getnewslist(parame) {
    //   this.newslistParame.LoginUserId = this.$storage.get("PCUserId");
    //   this.$axios({
    //     method: "post",
    //     url: "/api/OwUserNews/GetOwUserNewsList", //
    //     data: parame
    //   })
    //     .then(response => {
    //       if (response.State == "1") {
    //         this.newSData = response.Data;
    //         document.getElementById("out-box").scrollIntoView();
    //         // if (response.Data.ReadCount > 0) {
    //         //   this.ifDot = true;
    //         // } else {
    //         //   this.ifDot = false;
    //         // }
    //       } else {
    //         this.$message({
    //           message: response.Msg,
    //           type: "warning",
    //           customClass: "alertStyle",
    //           duration: "1500"
    //         });
    //       }
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },
    closealert(){
      this.popalert=false;
      this.popmask.close();
      sessionStorage.setItem('ispop','true')
    },
    showalert(b){
      if(!sessionStorage.getItem('ispop')){
        this.popmask=Loading.service({ target: 'body', background:'rgba(0,0,0,0.6)'});
        this.hotpop=true;
        this.popalert=true;
      } 
      if(b){
        this.getbnum=b;
        this.getb=true;
        this.hotpop=false;
         this.popmask=Loading.service({ target: 'body', background:'rgba(0,0,0,0.6)'});
        this.popalert=true;

      }
    },
    searchWorks(e) {
      if (e) {
        console.log(e);
        if (e.keyCode == 13) {
          this.searchFlag = false;
          this.$router.push("/design/search?searchText=" + this.inputText);
        }
      }
    },
    searchInputShow(e) {
      this.inputText = "";
      $("#btnsearch").hide();
      $("#navMenu").hide();
      $(".mainsearchBox").show();
      $("#inputText").focus();
      // this.searchFlag = true;
    },
    searchInputHide() {
      // this.searchFlag = false;
      $(".mainsearchBox").hide();
      $("#btnsearch").show();
      $("#navMenu").show();
    },
    // searchInput() {
    //   this.inputText = "";
    //   this.searchFlag = !this.searchFlag;
    // },
    goLink() {
      var tempwindow = window.open("_blank"); //打开一个窗口，然后用
      tempwindow.location = "http://beian.miit.gov.cn/";
    },
    goTop(e) {
      document.getElementById("out-box").scrollIntoView();
      // this.goTopFlag = false;
      $("#to-top-btn").hide();
    },
    // byNewsSon() {
    //   console.log("系统公告调我呢");
    //   if (this.hasToken) {
    //     this.newslistParame.Paging.PageIndex = 1;
    //     this.getnewslist(this.newslistParame);
    //   }
    // },
    bySon() {
      // alert("儿子调我呢");
      this.loginVisible = true;
    },
    activeSon() {
      if (this.$storage.get("token")) {
        // this.hasToken = true;
        this.getUserDetail();
      } else {
        this.hasToken = false;
      }
      let str = this.$route.name.toLowerCase();
      this.$root.eventHub.$emit(str);
    },
    dialogChange(val) {
      this.loginVisible = val.loginVisible;
      if (val.loginVisible == false && this.$storage.get("token")) {
        this.hasToken = true;
      }
    },
    // goNews() {
    //   // this.ifDot = false;

    //   this.searchInputHide();
    //   this.$router.push("/design/NewsList");
    // },
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        var clientHeight =
          document.body.clientHeight < document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      } else {
        var clientHeight =
          document.body.clientHeight > document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      }
      return clientHeight;
    },

    // fetchSourceData(callback) {
    //   return new Promise((resolve, reject) => {
    //     resolve(this.getOssToken());
    //   });
    // },
    /*获取图片用来展示*/
    // showImgs(toreAs) {
    //   var client = new OSS({
    //     accessKeyId: this.accessKeyId,
    //     accessKeySecret: this.accessKeySecret,
    //     stsToken: this.stsToken,
    //     endpoint: this.endpoint,
    //     bucket: this.bucket
    //   });
    //   // process:"image/resize,w_316,h_200/auto-orient,1/quality,q_90/format,src"
    //   var signUrl = client.signatureUrl(toreAs, {
    //     expires: 600
    //   });
    //   return signUrl;
    // },
    // getOssToken() {
    //   this.$axios({
    //     method: "post",
    //     url: "/api/OSS/OwGetToken",
    //     data: { data: 0 }
    //   })
    //     .then(success => {
    //       if (success.State == 1) {
    //         console.log("111");
    //         this.accessKeyId = success.Data.AccessKeyId;
    //         this.accessKeySecret = success.Data.AccessKeySecret;
    //         this.stsToken = success.Data.SecurityToken;
    //         this.endpoint = success.Data.Endpoint;
    //         this.bucket = success.Data.Bucket;
    //         this.$storage.set("PCAccessKeyId", success.Data.AccessKeyId);
    //         this.$storage.set(
    //           "PCAccessKeySecret",
    //           success.Data.AccessKeySecret
    //         );
    //         this.$storage.set("PCStsToken", success.Data.SecurityToken);
    //         this.$storage.set("PCEndpoint", success.Data.Endpoint);
    //         this.$storage.set("PCBucket", success.Data.Bucket);
    //         return;
    //       }
    //       this.thenFn(success.State, success.Msg);
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    getUserDetail() {
      let that = this;
      api({
        method: "get",
        url: "/api/user/info",
        data: {
          id: that.$storage.get("id"),
        },
      })
        .then((response) => {
          if (response.code == 200) {
            this.UserMainData = response.data;
            this.hasToken = true;
            this.loginVisible = false;
            this.$forceUpdate();
            if(this.UserMainData.addCoin>0){
              // this.showalert(this.UserMainData.addCoin)
            }
            
          } else {
            localStorage.clear();
            this.hasToken = false;
            this.loginVisible = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loginProject() {
      this.loginVisible = true;
    },
    footernav(type) {
      location.href = "/Design/footernav?type=" + type;
    },
    registered() {
      this.loginVisible = false;
      this.registeredVisible = true;
    },
    passwordInput(e) {
      console.log(e.target.value);
      if (e.target.value != "") {
        this.haveContent = true;
      }
      // if(e.target.value)
    },
    passwordSureInput(e) {
      if (e.target.value != "") {
      }
    },
    // loginVisible
    loginPasswordVisible() {
      this.$refs.inputLoginPassword.type = "password";
      this.visibleLoginFlag = false;
    },
    loginPasswordNotVisible() {
      this.$refs.inputLoginPassword.type = "text";
      this.visibleLoginFlag = true;
    },
    passwordVisible() {
      this.$refs.inputPassword.type = "password";
      this.visibleLoginFlag = false;
    },
    passwordNotVisible() {
      this.$refs.inputPassword.type = "text";
      this.visibleLoginFlag = true;
    },
    passwordSureVisible() {
      this.$refs.inputSurePassword.type = "password";
      this.visibleSureFlag = false;
    },
    passwordSureNotVisible() {
      this.$refs.inputSurePassword.type = "text";
      this.visibleSureFlag = true;
    },
    // loginData(e, type) {
    //   let value = e.target.value;
    //   // 邮箱正则
    //   if (type == 1) {
    //     let regEmail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    //     if (!regEmail.test(value)) {
    //       this.emailLoginFlag = true;
    //       return false;
    //     } else {
    //       this.emailLoginFlag = false;
    //     }
    //   }
    // },
    // regRegisterData(e, type) {
    //   let value = e.target.value;
    //   // 邮箱正则
    //   if (type == 1) {
    //     let regEmail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    //     if (!regEmail.test(value)) {
    //       this.emailFlag = true;
    //       return false;
    //     } else {
    //       this.emailFlag = false;
    //     }
    //   }
    //   if (type == 2) {
    //     let regPassword = /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{8,18}$/;
    //     if (!regPassword.test(value)) {
    //       this.passwordFlag = true;
    //       return false;
    //     } else {
    //       this.passwordFlag = false;
    //     }
    //   }
    //   if (type == 3) {
    //     if (this.registerData.Model.Password) {
    //       this.havePassword = false;
    //       if (this.surePassword != this.registerData.Model.Password) {
    //         this.sameFlag = true;
    //         return false;
    //       } else {
    //         this.sameFlag = false;
    //       }
    //     } else {
    //       this.havePassword = true;
    //     }
    //   }
    // },

    gosearch() {
      this.searchFlag = false;
      this.$router.push("/design/search?searchText=" + this.inputText);
    },
    gouploadwork() {
      // if (this.$route.meta.title == "上传作品") {
      //   location.reload();
      // }
      if (this.hasToken) {
        let routeData = this.$router.resolve({
          name: "/design/uploadwork",
        });
        console.log(routeData);
        window.open("/design/uploadwork" + routeData.href, "_blank");
        this.searchInputHide();
        // this.$router.push("/design/uploadwork?from=" + this.activeIndex);
      } else {
        localStorage.clear();
        this.loginVisible = true;
      }
    },
    handleCommand(command) {
      if (command == "d") {
        this.$router.push("/design/usercentersetting");
      }
      if (command == "a" || command == "b" || command == "c") {
        this.$router.push("/design/usercenter?flag=" + command);
      }
      if (command == "f") {
        this.$router.push("/design/personalCenter");
      }
      if (command == "e") {
        localStorage.clear();
        sessionStorage.clear()
        this.hasToken = false;
        this.$router.push("/");

        // if (
        //   this.$route.name == "uploadwork" ||
        //   this.$route.name == "usercentersetting" ||
        //   this.$route.name == "usercenter"
        // ) {
        //   this.$router.push("/");
        // } else {
        //   let str = this.$route.name.toLowerCase();
        //   this.$root.eventHub.$emit(str);
        // }

        // if (
        //   this.$route.name == "uploadwork" ||
        //   this.$route.name == "usercentersetting" ||
        //   (this.$route.query.usercenterFWUserId &&
        //     this.$storage.get("PCUserId") &&
        //     this.$route.query.usercenterFWUserId ==
        //       this.$storage.get("PCUserId"))
        // ) {
        //   this.$router.push("/");
        // } else {
        //   this.$router.push(this.$route.fullPath);
        // }

        //   console.log(this.$route);
        //   localStorage.clear();
        //   location.href = "http://www.tuuux.com" + this.$route.fullPath;
        //   // this.hasToken = false;
        //   // this.$router.push(this.$route.fullPath);
        // }
      }
    },
    gousercenter() {
      this.$router.push("/design/usercenter");
    },
    handleSelect(key) {
      sessionStorage.setItem("menuIdenx", key);
      if (key == 1) {
        if (this.$route.meta.title == "首页") {
          location.reload();
        } else {
          this.$router.push("/");
        }
      }
      if (key == 2) {
        if (this.$route.meta.title == "作品") {
          location.reload();
        } else {
          this.$router.push("/design/works");
        }
      }
      if (key == 3) {
        if (this.$route.meta.title == "工具列表") {
          location.reload();
        } else {
          this.$router.push("/design/toollist");
        }
      }

      if (key == 4) {
        if (this.$route.meta.title == "资源") {
          location.reload();
        } else {
          this.$router.push("/resource/index");
        }
      }

      if (key == 5) {
        if (this.$route.meta.title == "教程") {
          location.reload();
        } else {
          this.$router.push("/course/index");
        }
      }

      if (key == 6) {
        if (this.$route.meta.title == "周练") {
          location.reload();
        } else {
          this.$router.push("/week/index");
        }
      }

      if (key == 7) {
        if (this.$route.meta.title == "企业合作") {
          location.reload();
        } else {
          this.$router.push("/design/businessComperation");
        }
      }

      if (key == 8) {
        if (this.$route.meta.title == "软件下载") {
          location.reload();
        } else {
          this.$router.push("/software/index");
        }
      }

      if (key == 9) {
        if (this.$route.meta.title == "新闻大事件") {
          location.reload();
        } else {
          this.$router.push("/news/index");
        }
      }
      if (key == 10) {
        if (this.$route.meta.title == "图象超级助理") {
          location.reload();
        } else {
          this.$router.push("/plugin/download");
        }
      }
      
    },
    gohome() {
      location.href = "/";
    },
    goWorks() {
      location.href = "/design/works";
    },
    goTool() {
      location.href = "/design/toollist";
    },
    remWatch() {
      let than = this;
      // $(".out-box").css("min-width", "900px");
      $(window).resize(function () // 绑定到窗口的这个事件中
      {
        let height = 0;
        if (window.innerWidth >= 1600) {
          height = parseFloat(than.getClientHeight()) - 260;
        } else {
          height = parseFloat(than.getClientHeight()) - 217;
        }
        // 计算content-box 最小高度
        $(".content-box").css("min-height", height + "px");
      });
      let height = 0;
      if (window.innerWidth >= 1600) {
        height = parseFloat(than.getClientHeight()) - 260;
      } else {
        height = parseFloat(than.getClientHeight()) - 217;
      }
      // 计算content-box 最小高度
      $(".content-box").css("min-height", height + "px");
    },
  },
};
</script>
<style lang="less">
.MainMenu {
  width: 100px !important;
}
#navMenu .el-menu-item {
  padding: 0 15px;
}
.el-menu-item:hover {
  color: rgb(62, 102, 245) !important;
}
@media screen and (max-width: 1600px) {
  .mainsearchBox {
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 500px !important;
    margin-left: -250px;
    margin-top: -20px;
    height: 40px;
    line-height: 40px;
    .el-input {
      display: inline-block;
      width: 430px;
      height: 40px;
      float: left;
      // margin-left: 10px;
      // margin-right: 10px;
      .el-input__inner {
        border: none !important;
        position: absolute;
        top: 0px;
        width: 100%;
        left: 0;
        height: 100%;
      }
    }
    a:first-child {
      float: left;
      i {
        font-size: 16px !important;
      }
    }
    a {
      display: inline-block;

      height: 40px;
      line-height: 40px;
      i {
        font-weight: bold;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
  .el-menu-demoMain {
    display: inline-block;
    float: left;
  }
  .loginDialog {
    /* width: 6.28rem !important; */
    margin-top: 0 !important;
    background: none;
    width: 666px;
    transform: translateY(-50%);
    top: 50%;
  }
  .registeredDialog,
  .registeredSuccessDialog {
    width: 523px !important;
    margin-top: 0 !important;
    background: #ffffff;
    border-radius: 8px;
    /* height: 5rem; */

    /* margin-top: 2.5rem !important; */
    transform: translateY(-50%);
    top: 50%;
  }
  .registeredDialog .el-dialog__body {
    padding: 30px 20px;
  }
  .registeredDialog .el-checkbox__inner {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  /* 登录弹框 */
  .loginDialog .el-dialog__body {
    padding: 0px;
  }
  .loginDialog .el-dialog__header,
  .registeredDialog .el-dialog__header,
  .registeredSuccessDialog .el-dialog__header {
    padding: 0px;
    height: 0px;
  }
}
@media (min-width: 1600px) {
  .mainsearchBox {
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 600px !important;
    margin-left: -300px;
    margin-top: -27px;
    height: 54px;
    line-height: 54px;
    .el-input {
      display: inline-block;
      width: 540px !important;
      float: left;
      height: 50px;
      // margin-left: 10px;
      // margin-right: 10px;
      .el-input__inner {
        border: none !important;
        position: absolute;
        top: 0px;
        width: 100%;
        left: 0;
        height: 100%;
      }
    }
    a:first-child {
      float: left;
      i {
        font-size: 16px !important;
      }
    }
    a {
      display: inline-block;
      height: 50px;
      line-height: 50px;
      i {
        font-weight: bold;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
  .el-menu-demoMain {
    display: inline-block;
    float: left;
  }
  .loginDialog {
    /* width: 6.28rem !important; */
    margin-top: 0 !important;
    background: none;
    width: 800px;
    transform: translateY(-50%);
    top: 50%;
  }
  .registeredDialog {
    padding-bottom: 71px;
  }
  .registeredDialog,
  .registeredSuccessDialog {
    width: 628px !important;
    margin-top: 0 !important;
    background: #ffffff;
    /* height: 500px; */
    border-radius: 9px;
    transform: translateY(-50%);
    top: 50%;
  }
  .registeredSuccessDialog {
    height: 500px;
  }
  .registeredDialog .el-dialog__body,
  .registeredSuccessDialog .el-dialog__body {
    padding: 0 !important;
  }
  .registeredDialog .el-checkbox__inner {
    width: 12px;
    height: 12px;
    margin-right: 6px;
  }

  /* 登录弹框 */
  .loginDialog .el-dialog__body {
    padding: 0px;
  }
  .loginDialog .el-dialog__header,
  .registeredDialog .el-dialog__header,
  .registeredSuccessDialog .el-dialog__header {
    padding: 0px;
    height: 0px;
  }
}
</style>
<style lang="less" scoped>
@media (min-width: 1600px) {
  .goTop {
    position: fixed;
    display: inline-block;
    width: 48px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    color: #fff;
    right: 15px;
    bottom: 189px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.3);
    box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
    border-radius: 2px;
    i {
      font-size: 26px;
      // font-weight: bold;
    }
  }
  .out-box {
    /* min-width: 1100px;*/
    background: #f1f3f6;
    .content-box {
      // max-width: 1200px;
      // width: 1200px;
      margin: 0 auto;
    }
    .el-menu--horizontal > .el-menu-item.is-active {
      border-bottom: 0px;
      a {
        font-size: 14px;
        color: #3d65f4 !important;
        font-weight: 600;
      }
    }
    .el-menu--horizontal > .el-menu-item {
      border-bottom: 0px;
      font-size: 14px;
      color: #282828 !important;
      // font-weight: 600;
    }
    .el-menu.el-menu--horizontal {
      border-bottom: 0px;
      height: 100%;
    }
    .el-menu--horizontal > .el-menu-item {
      height: 70px;
      line-height: 70px;
      color: #282828 !important;
      // font-weight: 600;
    }

    .logo {
      height: 30px;
      vertical-align: middle;
    }
    .header-box {
      background: #fff;
      overflow: hidden;
      // box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.09);
      // box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.09);
      // padding: 0 30px;
      border-bottom: 1px solid #e1e6f0;
    }
    .header {
      height: 70px;
      line-height: 70px;
      width: 1380px;
      // max-width: 1200px;
      overflow: hidden;
      margin: 0 auto;
      position: relative;
      a.logoBox {
        height: 65px;
        width: 200px;
        float: left;
        margin-top: 5px;
        outline: none;
      }
      svg {
        height: 65px;
        width: 200px;
        float: left;
        // margin-top: 5px;
        outline: none;
      }
      .funcIcon {
        display: inline-block;
        float: right;
        outline: none;
        ul {
          outline: none;
          height: 22px;
          line-height: 22px;
          margin-top: 23px;
          display: inline-block;
          // float: right;
          outline: none;
          height: 22px;
          line-height: 22px;
          margin-top: 23px;
        }
        li.redDotBox {
          position: relative;
          .redDot {
            height: 16px;
            background: #f4523b;
            border-radius: 10px;
            padding: 0 4px;
            font-size: 12px;
            color: #f9f9f9;
            vertical-align: middle;
            line-height: 16px;
            margin: 0 0 2px 3px;
            position: absolute;
            top: -3px;
            right: -4px;
          }
        }
        li {
          display: inline-block;
          padding: 0 10px;
          border-right: 1px solid #e1e6f0;
          height: 22px;
          line-height: 22px;
          float: left;

          .el-dropdown-link {
            margin-top: -3px;
            margin-left: 25px;
            outline: none;
            svg {
              height: 30px;
              width: 30px;
              float: right;
            }
            img {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              outline: none;
            }
          }

          i {
            font-size: 18px;
            color: #374567;
          }
          i:hover {
            color: rgb(62, 102, 245);
          }
        }
        span.commonSpan {
          height: 32px;
          line-height: 32px;
          // padding: 0 10px;
          display: inline-block;
          width: 68px;
          text-align: center;
          border-radius: 2px;
          font-size: 14px;
          float: right;
          margin-top: 18px;
          cursor: pointer;
        }
        span.registered {
          background: #3d65f4;
          color: #ffffff;
          border: 1px solid #3d65f4;
          margin-right: 20px;
          margin-left: 10px;
        }
        span.login {
          background: #ffffff;
          color: #3d65f4;
          border: 1px solid #3d65f4;
        }

        // li:nth-of-type(2) {
        //   i {
        //     font-size: 22px;
        //   }
        // }
        li:nth-of-type(3) {
          border-right: 0;
        }
        li:last-child {
          border-right: 0;
        }
      }
    }
    .footerBox {
      height: 189px;
      width: 100%;
      background: #0a1733;
      .footer {
        max-width: 1380px;
        margin: 0 auto;
        .foot_logo {
          float: left;
          margin-right: 80px;
          img {
            height: 24px;
          }
        }
        .contentList {
          float: left;
          margin-top: 76px;
          ul {
            margin-bottom: 15px;
            li {
              float: left;
              font-size: 16px;
              margin-right: 37px;
              a {
                color: #ffffff;
              }
            }
            li:last-child {
              margin-right: 0px;
            }
          }
          .copyright {
            font-size: 16px;
            color: #656b7e;
            cursor: pointer;
          }
        }
        .qrCode {
          float: right;
          .qrCodeBox {
            display: inline-block;
            width: 83px;
            margin-top: 33px;
            p {
              font-size: 13px;
              color: #fff;
              text-align: center;
              line-height: 20px;
            }
          }
          img {
            width: 83px;
            height: 83px;
          }
          .qrCodeBox:first-child {
            margin-right: 34px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .goTop {
    position: fixed;
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;

    color: #fff;
    right: 15px;
    bottom: 158px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.3);
    box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
    border-radius: 2px;
    i {
      font-size: 26px;
      // font-weight: bold;
    }
  }
  .out-box {
    min-width: 1100px;
    background: #f1f3f6;
    .content-box {
      // max-width: 1200px;
      // width: 1200px;
      margin: 0 auto;
    }
    .el-menu--horizontal > .el-menu-item.is-active {
      border-bottom: 0px;
      a {
        font-size: 14px;
        color: #3d65f4 !important;
        font-weight: 600;
      }
    }
    .el-menu--horizontal > .el-menu-item {
      border-bottom: 0px;
      font-size: 14px;
      color: #282828 !important;
    }
    .el-menu.el-menu--horizontal {
      border-bottom: 0px;
      height: 100%;
    }
    .el-menu--horizontal > .el-menu-item {
      height: 58px;
      line-height: 58px;
      color: #282828 !important;
    }

    .logo {
      height: 30px;
      vertical-align: middle;
    }
    .header-box {
      background: #fff;

      // box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.09);
      // box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.09);
      // padding: 0 30px;
      border-bottom: 1px solid #e1e6f0;
    }
    .header {
      height: 58px;
      line-height: 58px;
      // width:1000px;
      max-width: 1150px;
      margin: 0 auto;
      position: relative;

      svg,
      a.logoBox {
        height: 52px;
        width: 160px;
        float: left;
        margin-top: 3px;
        outline: none;
      }
      svg {
        margin-top: 0px;
      }
      .funcIcon {
        display: inline-block;
        float: right;
        outline: none;
        ul {
          outline: none;
          height: 27px;
          line-height: 27px;
          margin-top: 15px;
          display: inline-block;
        }
        li.redDotBox {
          position: relative;
          .redDot {
            height: 16px;
            background: #f4523b;
            border-radius: 10px;
            padding: 0 4px;
            font-size: 12px;
            color: #f9f9f9;
            vertical-align: middle;
            line-height: 16px;
            margin: 0 0 2px 3px;
            position: absolute;
            top: -2px;
            right: -4px;
          }
        }
        li {
          display: inline-block;
          padding: 0 8px;
          border-right: 1px solid #e1e6f0;
          height: 27px;
          line-height: 27px;
          float: left;
          .el-dropdown-link {
            margin-top: -3px;
            margin-left: 25px;
            outline: none;
            svg {
              height: 30px;
              width: 30px;
              float: right;
              margin-top: 2px;
            }
            img {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              margin-top: 2px;
              outline: none;
            }
          }

          i {
            font-size: 18px;
            color: #374567;
          }
          i:hover {
            color: rgb(62, 102, 245);
          }
        }
        span.commonSpan {
          height: 27px;
          line-height: 27px;
          // padding: 0 10px;
          display: inline-block;
          width: 57px;
          text-align: center;
          border-radius: 2px;
          font-size: 12px;
          float: right;
          margin-top: 15px;
          cursor: pointer;
        }
        span.registered {
          background: #3d65f4;
          color: #ffffff;
          border: 1px solid #3d65f4;
          margin-right: 17px;
          margin-left: 9px;
        }
        span.login {
          background: #ffffff;
          color: #3d65f4;
          border: 1px solid #3d65f4;
        }

        // li:nth-of-type(2) {
        //   i {
        //     font-size: 22px;
        //   }
        // }
        li:nth-of-type(3) {
          border-right: 0;
        }
        li:last-child {
          border-right: 0;
        }
      }
    }
    .footerBox {
      height: 158px;
      width: 100%;
      background: #0a1733;
      .footer {
        max-width: 1150px;
        margin: 0 auto;
        .foot_logo {
          float: left;
          margin-right: 73px;
          img {
            height: 22px;
          }
        }
        .contentList {
          float: left;
          margin-top: 63px;
          ul {
            margin-bottom: 13px;
            li {
              float: left;
              font-size: 13px;
              margin-right: 31px;
              a {
                color: #ffffff;
              }
            }
            li:last-child {
              margin-right: 0px;
            }
          }
          .copyright {
            font-size: 13px;
            color: #656b7e;
            cursor: pointer;
          }
        }
        .qrCode {
          float: right;
          .qrCodeBox {
            width: 69px;
            display: inline-block;
            margin-top: 26px;
            p {
              color: #fff;
              text-align: center;
              line-height: 18px;
              font-size: 12px;
            }
          }
          img {
            width: 69px;
            height: 69px;
          }
          .qrCodeBox:first-child {
            margin-right: 28px;
          }
        }
      }
    }
  }
}
#app .dialogbox {
  position: fixed;
  // width: 100%;
  display: table;
  padding: 10px;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  // background: rgba(0, 0, 0, 0.3);
  z-index: 99999;
}
#app .dialogbox .close{
  font-size: 40px;
  color: #ccc;
  position: absolute;
  right: -35px;
  top: 35px;
  cursor: pointer;
  
}
.nums{
  color: #f25d0a;
    position: absolute;
    left: 0;
    top: 44%;
    width: 100%;
    text-align: center;
    font-size: 60px;
    font-weight: bold;
    margin-left: 5%;
}
.el-loading-mask .is-fullscreen{
  background-color: rgba(0, 0, 0, 0.6) !important;
}
.new{
  transform: translate(-5px,-10px);
  width: 22px;
}
</style>



// WEBPACK FOOTER //
// src/Main.vue